/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Magnetic } from "../../styles/Semantic";
import { Button, ButtonStyle } from "../button";
const StyledCloseButton = () => css `
	padding: 0;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	height: 24px;
	width: 24px;
	color: ${Magnetic.colorNeutral60};
	&[disabled],
	&[disabled]:hover,
	&[disabled]:focus {
		pointer-events: none;
		cursor: default;
		background: transparent;
		color: ${Magnetic.disabledFontColor};
	}
`;
/**
 * Props for AssistanceModal component
 * * @param {number} size to determine size of the icon
 * @param {isBusy} isBusy to load the spinner for the Button when the component is Busy
 * @param {function():void} onClose callback triggered when close icon is clicked
 */
export const AssistanceModalCloseButton = ({ onClose, isBusy }) => {
    return (jsx(Button, { icon: "mi-icon-close", iconSize: 14, style: ButtonStyle.Flat, onClick: onClose, css: StyledCloseButton, disabled: isBusy }));
};
//# sourceMappingURL=AssistanceModalCloseButton.js.map